<template>
  <container :class="['section-blocks', 'my-6']">
    <flex :spacing="3">
      <flex-col :span="24">
        <h-three :title="$lang.sectionTitle($lang.sections[section], routes.length)" />
      </flex-col>
      <flex-col equal-height md8 sm12 xs12 :span="routes.length > 3 ? 6 : 8" v-if="!section.hidden" v-for="(section, index) in routes" :key="index">
        <card :title="tooltip ? null : section.title" v-tooltip="makeTooltip(section.title)" full-height tag="router-link" :to="section.path">
          <card-title v-if="title" :class="['truncate']" v-html="section.title" align="center" color="white" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
          <card-text align="center" :class="['py-8']">
            <icon :name="section.icon" :size="4" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'SectionBlocks',
  data () {
    return {
      routes: [],
      section: null
    }
  },
  props: {
    block: {
      type: String
    },
    title: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.getNavSections()
  },
  methods: {
    getNavSections () {
      const path = this.$route.path.split('/')
      const section = path[1] !== '' ? path[1] : 'getting-started'
      this.section = this.block ? this.block : section
      this.routes = this.$router.options.routes.filter(route => route.type === this.section)
    },
    makeTooltip (text, position = 'top') {
      if (this.tooltip) {
        return {position, text}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/section-blocks.vue